module.exports = __webpack_public_path__ + "b99bbc6ee388476fb7e8c691f7bfe7a0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/zigzag.png
// module id = 3379
// module chunks = 0